import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default, { useContext } from 'react';
import Tooltip from '../Tooltip.js';
import { SideNavContext, SideNavGroupContext } from './index.js';

var _excluded = ["as", "className", "children", "isGroupHeader", "onClick", "selected"];
var SideNavNavigationItem = function SideNavNavigationItem(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'button' : _ref$as,
    className = _ref.className,
    children = _ref.children,
    _ref$isGroupHeader = _ref.isGroupHeader,
    isGroupHeader = _ref$isGroupHeader === void 0 ? false : _ref$isGroupHeader,
    onClick = _ref.onClick,
    selected = _ref.selected,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var parentContext = useContext(SideNavContext);
  var groupContext = useContext(SideNavGroupContext);
  var finalClasses = classnames('C-SideNav__NavigationItem', {
    isSelected: selected
  }, className);
  var handleDefaultOnClick = function handleDefaultOnClick() {
    onClick && onClick();
    !isGroupHeader && parentContext.handleAutoClose();
  };
  var handleMinimizedOnClick = function handleMinimizedOnClick() {
    onClick && onClick();
  };
  var childrenToBeRendered = [];
  var tooltipText = [];

  // logic to see if we are missing any needed icons
  var checkForIcons = function checkForIcons(children) {
    var hasIconChild = false;
    children = Array.isArray(children) ? children : [children];
    children.map(function (child) {
      var _child$type;
      if ((child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'EnterpriseIcon') {
        hasIconChild = true;
      }
    });
    if (!hasIconChild) {
      console.error("Hey Canvas User! The collapsable SideNav needs the ".concat(children, " SideNav.NavigationItem to have an EnterpriseIcon sibling."));
    }
  };

  // if isMinimized and not in a group, then show only icons
  if (parentContext !== null && parentContext !== void 0 && parentContext.isMinimized && !groupContext) {
    // get tooltip content from children
    for (var i = 0; i < children.length; i++) {
      var _children$i, _children$i$type;
      if (((_children$i = children[i]) === null || _children$i === void 0 ? void 0 : (_children$i$type = _children$i.type) === null || _children$i$type === void 0 ? void 0 : _children$i$type.displayName) === 'EnterpriseIcon') {
        childrenToBeRendered.push(children[i]);
      } else {
        tooltipText.push(children[i]);
      }
    }
    // if there is a prop of data-tooltip on the navigation item parent, that overrides any child content
    if (otherProps['data-tooltip']) {
      tooltipText = otherProps['data-tooltip'];
    }
    // make sure if we need icons for the iconsOnly nav, we have them
    checkForIcons(children);
  }

  // rendering for children inside a dropdown group when minimized
  if (parentContext !== null && parentContext !== void 0 && parentContext.isMinimized && groupContext !== null && groupContext !== void 0 && groupContext.isInDropdownGroup) {
    var childrenMinusIcons = [];
    for (var _i = 0; _i < children.length; _i++) {
      var _children$_i$type;
      if (((_children$_i$type = children[_i].type) === null || _children$_i$type === void 0 ? void 0 : _children$_i$type.displayName) !== 'EnterpriseIcon') {
        childrenMinusIcons.push(children[_i]);
      }
      if (_i + 1 === children.length) {
        return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(As, _extends({
          tabIndex: "0",
          className: finalClasses
        }, otherProps, {
          key: tooltipText,
          onClick: handleMinimizedOnClick,
          children: childrenMinusIcons
        })));
      }
    }
  }

  // rendering for children outside a group when minimized
  if (parentContext !== null && parentContext !== void 0 && parentContext.isMinimized && !groupContext) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      content: tooltipText,
      location: "right"
    }, /*#__PURE__*/React__default.createElement(As, _extends({
      onClick: handleMinimizedOnClick,
      className: finalClasses
    }, otherProps), childrenToBeRendered));
  }
  var orderChildren = function orderChildren() {
    var orderedChildren = [];
    React__default.Children.toArray(children).map(function (child) {
      var _child$type2;
      if ((child === null || child === void 0 ? void 0 : (_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'EnterpriseIcon') {
        orderedChildren.unshift(child);
      } else {
        orderedChildren.push(child);
      }
    });
    return orderedChildren;
  };

  // non-minimized children rendering
  return /*#__PURE__*/React__default.createElement(As, _extends({
    onClick: handleDefaultOnClick,
    className: finalClasses
  }, otherProps), orderChildren());
};
SideNavNavigationItem.displayName = 'SideNav.NavigationItem';

export { SideNavNavigationItem as default };
